import React, { useEffect, useState } from 'react';
// import theme from 'assets/theme';
import ScrollTop from 'libs/commons/ScrollTop';
import LayoutWrapper from 'LayoutWrapper';
import StateProvider from 'providers/StateProvider';
import { Slide, ToastContainer } from 'react-toastify';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import NotFoundPage from 'pages/NotFoundPage';

// import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Confirm, Drawer, Modal, ModelStateProvider } from 'saladsoft-primitive';
import 'resources/css/Common.css';
import 'react-toastify/dist/ReactToastify.css';
import { LocalProvider } from 'providers/LocalProvider';
import ServiceHelper from 'stores/ServiceHelper';

const App = () => {

  const redirectByRoleType = async () => {
    const userInfo = await ServiceHelper.myAccountService?.getMyAccount();
    if (userInfo?.data?.roleType === 'ADMIN') {
      window.location.href = '/management/reservations/daily';
    } else {
      window.location.href = '/admin/listings';
    }
  };

  useEffect(() => {
    if (window.location.pathname === '/') {
      redirectByRoleType();
    }
  }, []);
  return (
    <LocalProvider>
      <ModelStateProvider>
        <CssBaseline />
        <BrowserRouter>
          <StateProvider>
            <ScrollTop />
            <Drawer />
            <Modal />
            <Confirm />
            <Routes>
              <Route path="/*" element={<LayoutWrapper />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            <ToastContainer
              position="bottom-center"
              autoClose={1000}
              style={{ width: '100%', maxWidth: '500px' }}
              hideProgressBar
              newestOnTop
              closeOnClick
              transition={Slide}
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
          </StateProvider>
        </BrowserRouter>
      </ModelStateProvider>
    </LocalProvider>
  );
};

export default App;
